module.exports = __webpack_public_path__ + "images/landing/light/light-presentation-image.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/light-presentation-image.png
// module id = KV5y
// module chunks = 118